var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"money-input",attrs:{"label":_vm.label,"background-color":"numeric","outlined":""},on:{"input":_vm.onInput,"blur":_vm.onBlur},model:{value:(_vm.formattedValue),callback:function ($$v) {_vm.formattedValue=$$v},expression:"formattedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }